import { err, ok } from 'neverthrow'
import { ConceptValueModelList } from '../../../concept/ConceptValueModelList'
import { Physician } from '../../../formmodel/Physician'
import { evaluatorErrorWithNode } from '../../scriptevaluator/EvaluatorError'
import { functionNodeTypes, HelperFunction } from '../FunctionTypes'

export const IsPcpFunction: HelperFunction = {
	tokenName: 'IS_PCP',
	nodeType: functionNodeTypes.IsPcp,
	evaluate(node, evaluateExpr) {
		if (node.arguments.length !== 1) {
			return err(evaluatorErrorWithNode('IS_PCP function expects exactly one argument', node))
		}
		const result = evaluateExpr(node.arguments[0])
		if (result.isErr()) return err(result.error)
		if (result.value === undefined || Array.isArray(result.value)) return ok(false)
		const list = new ConceptValueModelList<Physician>(result.value)
		for (const model of list.list) {
			if (model.IsPCP) return ok(true)
		}
		return ok(false)
	}
}
